export default __webpack_public_path__ + "static/media/tge-logo-lockup-white.b663ca08.svg";